import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoDrawer } from "@redotech/redo-web/arbiter-components/modal/redo-drawer";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, type ReactNode } from "react";
import * as styles from "./fulfillment-panel-drawer.module.css";

export interface FulfillmentPanelDrawerProps {
  children: ReactNode;
  onClose: () => void;
  open: boolean;
  panelId: string;
}

export const FulfillmentPanelDrawer = memo(function FulfillmentPanelDrawer({
  children,
  onClose,
  open,
  panelId,
}: FulfillmentPanelDrawerProps) {
  return (
    <RedoDrawer
      onModalCloseRequested={onClose}
      open={open}
      PaperProps={{ className: styles.fulfillmentPanel, id: panelId }}
      uiSelector={panelId}
    >
      <Flex
        bgColor="primary"
        dir="column"
        gap="none"
        height="full"
        overflow="hidden"
      >
        <Flex
          align="center"
          borderBottomWidth="1px"
          borderColor="primary"
          borderStyle="solid"
          justify="space-between"
          p="lg"
          shrink={0}
        >
          <Text fontSize="lg" fontWeight="semibold">
            Fulfillment details
          </Text>
          <RedoButton
            aria-controls={panelId}
            aria-expanded={open}
            aria-label="Close fulfillment details"
            data-testid="close-fulfillment-panel"
            hierarchy="tertiary"
            IconLeading={XCloseIcon}
            onClick={onClose}
            size="sm"
          />
        </Flex>
        <Flex
          className={styles.fulfillmentPanelBody}
          dir="column"
          grow={1}
          minH="none"
          overflow="hidden"
          position="relative"
          w="full"
        >
          {children}
        </Flex>
      </Flex>
    </RedoDrawer>
  );
});
